module.exports = __webpack_public_path__ + "assets/img/Dover Forest.0768fdef.jpg";